import React from 'react'
import { BaseSchema } from '../../../Schema/BaseSchema'
import { ServicePicker } from '../../../App/Services/Components/ServicePicker'
import { ConsigneeType } from '../../../Schema/ConsigneeSchema'

interface SchemaServicePickerProps {
  consigneeType?: ConsigneeType
  className?: any
  schema: BaseSchema
  label?: string
  field?: string
  helperText?: string
  onChange: Function
  disabled?: boolean
  required?: boolean
  variant?: 'standard' | 'filled' | 'outlined'
  placeholder?: string
  freeSolo?: boolean
  noOptionsText?: string
  clearOnBlur?: boolean
  enableCreate?: boolean
}

export const SchemaServicePicker: React.FC<SchemaServicePickerProps> = ({
  consigneeType,
  className,
  schema,
  field = 'serviceId',
  label = 'Service',
  helperText,
  onChange = (value: string, field: string) => {},
  disabled,
  required,
  variant,
  placeholder = 'Select a Service',
  freeSolo,
  noOptionsText,
  clearOnBlur,
  enableCreate,
}) => {
  return (
    <ServicePicker
      consigneeType={consigneeType}
      className={className}
      label={label}
      onChange={value => onChange(value, field)}
      disabled={disabled}
      required={required}
      variant={variant}
      placeholder={placeholder}
      freeSolo={freeSolo}
      noOptionsText={noOptionsText}
      clearOnBlur={clearOnBlur}
      enableCreate={enableCreate}
      error={schema.isPropertyInvalid(field)}
      helperText={schema.isPropertyInvalid(field) ? schema.getPropertyError(field) : helperText }
      value={schema.getValue(field) || null}
    />
  )
}
